import { publicCredit } from "./publicCredit";
import { getPublicUser } from "./getPublicUser";
import { createPublicCustomer } from "./createPublicCustomer";
import { createFGTSTransaction } from "./createFGTSTransaction";
import { increaseEntryCount } from "./increaseEntryCount";
import { getAllUserLinks } from "./getAllUserLinks";
import { getByIdLink } from "./getByIdLink";
import { getChartLink } from "./getChartLink";
import { checkName } from "./checkName";
import { createLink } from "./createLink";
import { getPartnersByLinkName } from "./getPartnersByLinkName";
import { createPanTransaction } from "./createPanTransaction";
import { generateOffersPan } from "./generateOffersPan";
import { makeProposalCrefaz } from "./makeProposalCrefaz";
import { createCrefazTransaction } from "./createCrefazTransaction";
import { uploadAttachmentCrefaz } from "./uploadAttachmentCrefaz";
import { getPublicTransactionPan } from "./getPublicTransaction";
import { selectOfferCrefaz } from "@/view/pages/Credit/components/FinalizationForm/selectOfferCrefaz";
import { getAttachmentCrefaz } from "./getAttachmentCrefaz";
import { sendProposalPan } from "./sendProposalPan";
import { getProposalPan } from "./getProposalPan";
import { getLinkFormalize } from "./getLinkFormalize";
import { simulateClt } from "./simulateClt";
import { createCltTransaction } from "./createCltTransaction";
import { getGender } from "./getGender";
import { getMaritalStatus } from "./getMaritalStatus";
import { getRelationshipDegree } from "./getRelationshipDegree";
import { updateTransactionCrefaz } from "./updateTransactionCrefaz";
import { updateLink } from "./updateLink";

export const selfHireService = {
  publicCredit,
  getPublicUser,
  createPublicCustomer,
  createFGTSTransaction,
  increaseEntryCount,
  getAllUserLinks,
  getByIdLink,
  getChartLink,
  checkName,
  createLink,
  getPartnersByLinkName,
  updateLink,

  createPanTransaction,
  generateOffersPan,
  getPublicTransactionPan,
  sendProposalPan,
  getProposalPan,
  getLinkFormalize,

  makeProposalCrefaz,
  selectOfferCrefaz,
  createCrefazTransaction,
  uploadAttachmentCrefaz,
  getAttachmentCrefaz,
  updateTransactionCrefaz,

  simulateClt,
  createCltTransaction,

  getGender,
  getMaritalStatus,
  getRelationshipDegree,
};
